import React, { useState } from 'react';
import { LoginScreen } from './components/LoginScreen';
import { MenuProduction } from './components/MenuProduction';
import { OfficeWorkspace } from './components/OfficeWorkspace';
import { useScreenInit } from './useScreenInit.js';
type AppScreen = 'login' | 'office' | 'production';
export function App() {
  const screenInit = useScreenInit();
  const [screen, setScreen] = useState<AppScreen>(screenInit.screen === 'production' ? 'production' : screenInit.screen === 'office' ? 'office' : 'login');
  const [username, setUsername] = useState(screenInit.screen === 'production' || screenInit.screen === 'office' ? 'Max' : '');
  function handleLogin(nextUsername: 'max' | 'maxpro') {
    setUsername('Max');
    setScreen(nextUsername === 'max' ? 'production' : 'office');
  }
  function handleLogout() {
    setUsername('');
    setScreen('login');
  }
  if (screen === 'production') {
    return <MenuProduction username={username} onLogout={handleLogout} initialView={screenInit.view === 'planned-orders' ? 'planned-orders' : 'menu'} data-id="element-0" />;
  }
  if (screen === 'office') {
    return <OfficeWorkspace username={username} onLogout={handleLogout} data-id="element-1" />;
  }
  return <LoginScreen onLogin={handleLogin} data-id="element-2" />;
}